import { useStore } from "@nanostores/react"

import { persistentAtom } from "@nanostores/persistent"

const MAX_HISTORY_ENTRIES = 5

const globalSearchHistoryAtom = persistentAtom<string[]>(
  "global-search-history",
  [],
  {
    encode: value => JSON.stringify(value),
    decode: str => {
      try {
        return str ? JSON.parse(str) : []
      } catch {
        return []
      }
    }
  }
)

export function addGlobalSearchHistoryEntry(query: string): void {
  const current = globalSearchHistoryAtom.get()
  const deduped = current.filter(q => q !== query)
  globalSearchHistoryAtom.set([query, ...deduped].slice(0, MAX_HISTORY_ENTRIES))
}

export function useGlobalSearchHistory(): string[] {
  return useStore(globalSearchHistoryAtom)
}
